<div class="p-1">
    <div class="search-wrapper">
        <!-- Selector (Dropdown) -->
        <div class="dropdown">
            <button class="btn btn-sm btnSelector dropdown-toggle" data-bs-toggle="dropdown">
                {{ selectedOption.label }}
            </button>
            <ul class="dropdown-menu">
                @for (opt of options; track $index) {
                <li (click)="selectOption(opt)">
                    <a class="dropdown-item" [ngClass]="{ 'active': selectedOption.value === opt.value }" >
                        {{ opt.label }}
                    </a>
                </li>
                }
            </ul>
        </div>
        <!-- Input con ícono dentro -->
        <div class="input-icon-container">
            <input
                #input
                class="custom-input-reactive border border-secondary-subtle w-100 text-ident"
                type="text"
                [(ngModel)]="inputValue"
                [placeholder]="placeholder"
                [maxlength]="selectedOption.value === 'phone' ? 12 : 50"
                (keypress)="onKeyPress($event)"
                (input)="onInput($event)"
            />
                @if(inputValue ){
                     <app-button
                        svg="mdi-delete-forever-outline-danger"
                        class="clear-icon"
                        colorIcon="--so-gray-thick"
                        [applyChanges]="true"
                        [scale]=".57"
                        [width]="'100%'"
                        (click)="clearInput()"
                    ></app-button>
                }
        </div>
            <button class="btn btn-sm btnSearch" (click)="doSearch()" style="height: 29px;">
                <so-icon
                    icon="search"
                    style="color: var(--so-white)!important; position:relative; bottom: 1px;"
                ></so-icon>
            </button>
    </div>
</div>